module.exports = __webpack_public_path__ + "static/media/velodrome_vincennes.778e7ec8.jpg";